<template>
  <b-card no-body>
    <div class="mr-4 ml-4 mt-4" style="height: ">
      <b-form-select
        class="mb-4 col-md-6"
        v-if="!!selected_membership && number_of_choices && number_of_choices != 0"
        v-model="selected_membership.membership_id"
        :options="membership_options"
        :disabled="classBusy"
      ></b-form-select>
      <Calendar
        :events="calendarEvents"
        :busy="busy || classBusy"
        @date="onDateChange"
        @view="onViewChange"
        @click="onEventClick"
      />
      <p v-if="number_of_choices && number_of_choices != 0" class="mt-2" style="font-weight: bold;">
        {{ trans('choices_classes').replace(':classes', number_of_classes).replace(':choices', number_of_choices)  }}
      </p>
    </div>
    <div class="pb-2 pt-2 text-center">
      <b-button class="shadow-none" v-if="futureCount > 0" variant="link" @click="show_future = !show_future; if (show_future) show_passed = false; showReturning = false;">
        {{ trans('upcoming') }} ({{ futureCount }})
        <i :class="`fa fa-fw fa-caret-${show_future ? 'down' : 'up'}`"></i>
      </b-button>
      <b-button class="shadow-none" v-if="passedCount > 0" variant="link" @click="show_passed = !show_passed; if (show_passed) show_future = false; showReturning = false;">
        {{ trans('passed') }} ({{ passedCount }})
        <i :class="`fa fa-fw fa-caret-${show_passed ? 'down' : 'up'}`"></i>
      </b-button>
      <b-button class="shadow-none" v-if="returningCount > 0" variant="link" @click="showReturning = !showReturning; show_future = false; show_passed = false;">
        {{ trans('returning') }} ({{ returningCount }})
        <i :class="`fa fa-fw fa-caret-${showReturning ? 'down' : 'up'}`"></i>
      </b-button>
    </div>
    <b-table
      id="class_events"
      ref="table"
      class="bg-white"
      responsive
      show-empty
      :fields="fields"
      :items="items"
    >
      <template v-slot:empty>
        <p align="center">
          <span v-if="!busy">{{ trans('no_events_today') }}</span>
          <span v-if="busy">
            <i class="fa fa-fw fa-circle-notch fa-spin" v-if="busy"></i>
            {{ trans('please_wait') }}
          </span>
        </p>
      </template>
      <template v-slot:cell(am_class_name)="data">
        <span v-if="!data.item.deleted_at">
          {{ data.value }} <span v-if="data.item.marked_absent_at">({{ trans('absent') }})</span>
        </span>
        <s v-else>
          {{ data.value }} 
        </s>
        <small style="display: block">{{ data.item.location_name }}</small>
      </template>
      <template v-slot:cell(recipient_name)="data">
        <span v-if="!data.item.deleted_at">
          {{ data.value }}
        </span>
        <s v-else>
          {{ data.value }}
        </s>
      </template>
      <template v-slot:cell(location_name)="data">
        <span>
          {{ data.value }}
        </span>
      </template>
      <template v-slot:cell(start)="data">
        <span v-if="!data.item.deleted_at">
          {{ data.value }}
        </span>
        <s v-else>
          {{ data.value }}
        </s>
      </template>
      <template v-slot:cell(zoom_meeting)="data">
        <div v-if="!!data.value && !data.item.deleted_at" class="mb-1">
          <div v-if="data.value.name">
            {{ data.value.name }}
            <br/>
            {{ moment(data.value.start).format('LLL') }},
            <small>
              <span class="text-muted">ID:</span>
              {{ formatZoomMeetingId(data.value.pmi || data.value.zoom_id) }}
            </small>
            <a :href="data.value.join_url" target="_blank" class="ml-2">
              Zoom
              <i class="fa fa-fw fa-external-link-alt"></i>
            </a>
          </div>
          <div>
            <small>
              <a :href="data.value.join_url" target="_blank">{{ data.value.join_url }}</a>
            </small>
          </div>
          <div v-if="data.value.password">
            <span class="text-muted">{{ trans('password') }}:</span>
            {{ data.value.password }}
          </div>
        </div>
      </template>
      <template #cell(action)="data">
          <b-dropdown
            v-if="canSeeDropDown(data.item)"
            variant="link"
            size="sm"
            class="p-0"
            toggle-class="text-muted"
            boundary="window"
            right
            :disabled="busy"
          >
            <template #button-content>
              <i class="fa fa-fw fa-ellipsis-h"></i>
            </template>
            <b-dropdown-item
              v-if="canAllowCancellation(data.item)"
              @click="cancelClass(data.item)"
              :disabled="!canCancelClassBeforeDropTimePeriod(data.item) && !adminCanChangeClient"
            >
              {{ trans('cancel') }} <span v-if="!canCancelClassBeforeDropTimePeriod(data.item)" class="small d-block text-muted" v-html="trans('cannot_cancel_class', {
                date: getLastValidCancelationDate(data.item).format('LLL')
              })"></span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="!canAllowCancellation(data.item) && canAllowCancellationAdmin(data.item) && !data.item.deleted_at"
              @click="cancelClass(data.item, true)"
              link-class="text-danger"
            >
              {{ `${trans('cancel')} (${trans('admin_option').toLowerCase()})` }} 
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canViewAttendace(data.item)"
              @click="viewAttendance(data.item)"
            >
              {{ trans('view_attendance') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canCheckIn(data.item)"
              @click="checkIn(data.item)"
            >
              <div :title="data.item.in_at ? trans('checkin_at', {time: moment(data.item.in_at).format('LLLL')}) : ''" v-b-tooltip.hover>
                <i class="fa fa-fw fa-check text-success" v-if="data.item.in_at"></i> {{ trans('attendance_export_choice_checkin') }}
              </div>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="data.item.am_class_meta.allow_cancellation && data.item.deleted_at"
              @click="goToDropInForm(data.item)"
            >
              {{ trans('view_drop_in_form') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="canMarkAbsent(data.item)"
              @click="markAbsent(data.item)"
            >
              <div :title="data.item.marked_absent_at ? trans('marked_absent_at', {time: moment(data.item.marked_absent_at).format('LLLL')}) : ''" v-b-tooltip.hover>
                <i class="fa fa-fw fa-check text-success" v-if="data.item.marked_absent_at"></i> {{ data.item.marked_absent_at ? trans('absent') : trans('mark_absent') }}
              </div>
            </b-dropdown-item>
          </b-dropdown>
      </template>
    </b-table>

    <AttendanceModal
      :organization="organization"
      :event="selected_event"
    />
  </b-card>
</template>

<script>
  import AttendanceModal from './AttendanceModal'
  import Calendar from './../../../common/components/Calendar'
  import BuyAddonsModal from './BuyAddonsModal'

  export default {
    props: {
      organization: Object,
      client: Object,
    },
    components: {
      Calendar,
      AttendanceModal,
      BuyAddonsModal
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        formatZoomMeetingId: _.formatZoomMeetingId,
        busy: false,
        classBusy: false,
        error: null,
        show_passed: false,
        show_future: false,
        class_events: [],
        membership_classes: [],
        membership_answers: [],
        forms: [],
        number_of_choices: null,
        number_of_choices_clean: null,
        number_of_classes: null,
        date: moment().format('YYYY-MM-DD'),
        view: 'timeGridWeek',
        selected_dates: [],
        membership_options: [],
        selected_membership: {},
        selected_event: {},
        can_see_action: false,
        showReturning: false,
        selectedRecipient: {}
      }
    },
    computed: {
      adminCanChangeClient() {
        return this.organization.auth_user &&
          this.organization.auth_user.can_connect_as_client //&& this.organization.has_memberships
      },
      showLocationColumn() {
        return _.reduce(this.class_events, (show, event) => {
          if (event.location_name) show = true
          return show
        }, false)
      },
      showParticipantColumn() {
        let recipientName = null
        return _.reduce(this.class_events, (show, event) => {
          if (!recipientName) recipientName = event.recipient_name
          if (event.recipient_name != recipientName) show = true
          return show
        }, false)
      },
      showZoomMeetingColumn() {
        return _.reduce(this.class_events, (show, event) => {
          if (!!event.zoom_meeting) show = true
          return show
        }, false)
      },
      fields() {
        return _.compact([
          {
            key: 'am_class_name',
            label: trans('class_event'),
          },
          this.showParticipantColumn ? {
            key: 'recipient_name',
            label: trans('participant'),
          } : null,
          {
            key: 'start',
            label: trans('date'),
            formatter(value, key, item) {
              return value ?
                (moment().isSame(value, 'day') ? (trans('today') + ' ' + moment(value).format('LT')) : moment(value).format('dddd LLL')) :
                null
            },
          },
          this.showZoomMeetingColumn ? {
            key: 'zoom_meeting',
            label: trans('zoom_meeting'),
          } : null,
          /*this.showLocationColumn ? {
            key: 'location_name',
            label: trans('location'),
          } : null,*/
          this.can_see_action || this.organization.id == 667 || this.organization.id == 1093 || this.organization.id == 3064 || this.organization.id == 133 || this.organization.id == 2147 ? {
            key: 'action',
          } : null,
        ])
      },
      items() {
        let startOfDay = moment().startOf('day')
        let endOfDay = moment().endOf('day')
        let events = _.reduce(this.class_events || [], (class_events, event) => {
          if ((!this.showReturning && startOfDay.isSame(event.start, 'day') ||
            (this.show_passed && endOfDay.isAfter(event.start) && !event.deleted_at) ||
            (this.show_future && startOfDay.isBefore(event.start) && !event.deleted_at)) || (this.showReturning && event.deleted_at && event.is_cancellable)) {
              class_events.push(event)
            }
          return class_events
        }, [])
        if (this.show_future) return _.reverse(events)
        return events
      },
      passedCount() {
        let startOfDay = moment().startOf('day')
        return _.reduce(this.class_events || [], (count, event) => {
          if (!moment(event.start).isAfter(startOfDay)) count += 1
          return count
        }, 0)
      },
      returningCount() {
        return _.reduce(this.class_events || [], (count, event) => {
          if (event.deleted_at && event.am_class_meta.allow_cancellation && event.is_cancellable) count += 1
          return count
        }, 0)
      },
      futureCount() {
        let endOfDay = moment().endOf('day')
        return _.reduce(this.class_events || [], (count, event) => {
          if (moment(event.start).isAfter(endOfDay)) count += 1
          return count
        }, 0)
      },
      calendarEvents() {
        let events = []	
        this.events.map((event) => {
          // check if has the same event id 
          let sameIdEvents = this.events.filter(x => x.id == event.id);
          if (sameIdEvents.length > 1) {
            // consolidate
            let sameIdEvent = sameIdEvents[0];
            if (!events.find(x => x.id == sameIdEvent.id)) {
              sameIdEvents.map((e, index) => {
                if (index > 0) {
                  sameIdEvent.extendedProps.client += `, ${e.extendedProps.client}`
                }
              })
              events.push(sameIdEvent)
            }
          } else {
            events.push(event)
          }
        });

        events = events.filter(event => !event.deleted_at)

        return events
      },
      events() {
        let events = []

        this.class_events.map((event) => {

          let eventName = event.am_class_name

          if (event.marked_absent_at) {
            eventName = `${eventName} (${trans('absent')})`
          }

          events.push({
            id: event.id,
            start: event.start,
            end: event.end,
            title: event.deleted_at ? `<s>${eventName}</s>` : eventName,
            borderColor: '#03a9f4',
            backgroundColor: '#e1f5fe',
            deleted_at: event.deleted_at,
            extendedProps: {
              isAttended: true,
              deleted: event.deleted_at,
              client: event.recipient_name,
            }
          })
        })

        if (this.membership_classes.length > 0) {
          events = [] // restarting events if has membership + classes
        }

        this.membership_classes.map((am_class) => {
          am_class.events.map((event) => {
            if (!!this.selected_membership &&
              moment(event.start).isAfter() &&
              moment(event.start).isBetween(this.selected_membership.active_at, this.selected_membership.expired_at)) {

              let isAttended = this.class_events.some(e => e.id == event.id)
              if (isAttended) {
                event.borderColor = '#03a9f4'
                event.backgroundColor = '#f8f9fa'
                event.extendedProps.isAttended = true
              } else {
                event.borderColor = '#DCDCDC'
                event.backgroundColor = '#DCDCDC'
                event.extendedProps.isAttended = false
              }

              events.push(event)
            }
          })
        })

        this.checkNumberOfClasses()

        return events
      }
    },
    methods: {
      buyAddons(item) {
        this.selectedRecipient = item
        this.$bvModal.show('buy-addons-modal')
      },
      canCheckIn(item) {
        return item.am_class_meta.can_check_in && moment().isSame(item.start, 'day')
      },
      canBuyAddons(item) {
        return item.am_class_meta.sale_addons
      },
      goToDropInForm(item) {
        window.location = item.am_class_meta.drop_in_form_url
      },
      canMarkAbsent(item) {
        return !item.deleted_at && !item.in_at && item.am_class_meta.can_mark_absence
      },
      canViewAttendace(item) {
        return !item.deleted_at && (item.am_class_meta.can_view_class_attendance 
        || item.am_class_id == 28832 
        || item.am_class_id == 57893 
        || item.am_class_id == 62963 
        || item.am_class_id == 42924)
      },
      canSeeDropDown(item) {
        return this.canAllowCancellation(item)
        || item.am_class_id == 28832 
        || item.am_class_id == 42924 
        || item.am_class_id == 57893 
        || item.am_class_id == 62963 
        || this.canCheckIn(item)
        || this.canMarkAbsent(item)
        || this.canViewAttendace(item)
        || (!this.canAllowCancellation(item) && this.canAllowCancellationAdmin(item))
        || (item.am_class_meta.allow_cancellation && item.deleted_at)
      },
      canAllowCancellation(item) {
        return item.am_class_meta 
        && item.am_class_meta.allow_cancellation 
        && item.am_class_meta.drop_in_form_url 
        && moment().isBefore(item.start) 
        && !item.deleted_at
      },
      canAllowCancellationAdmin(item) {
        return item.am_class_meta 
        && item.am_class_meta.allow_cancellation 
        && item.am_class_meta.drop_in_form_url 
        && this.adminCanChangeClient
      },
      canCancelClassBeforeDropTimePeriod(item) {
        // check if time is before the start time of the class
        if (!item.am_class_meta.drop_in_time_period || item.am_class_meta.drop_in_time_period == 0) {
          return true
        }

        let start = this.getLastValidCancelationDate(item)
        if (moment().isAfter(start)) {
          return false
        } else {
          return true
        }
      },
      getLastValidCancelationDate(item) {
        if (!item.am_class_meta.drop_in_time_period || item.am_class_meta.drop_in_time_period == 0) {
          return null
        }

        let start = moment(item.start).subtract(item.am_class_meta.drop_in_time_period, 'hours')
        return start
      },
      fetch() {
        this.busy = true
        this.error = null
        let query = `?page=${this.currentPage}&per_page=${this.perPage}&with_deleted=true`
        let url = `/org/${this.organization.id}/client/class_events${query}`
        return axios.get(url)
        .then(response => {
          this.busy = false
          let classEvents = []
          response.data.map((ce) => {
            if (ce.deleted_at) {
              if (ce.am_class_meta && ce.am_class_meta.allow_cancellation && !response.data.find(x => x.id == ce.id && !x.deleted_at)) {
                classEvents.push(ce)
              }
            } else {
              classEvents.push(ce)
            }
          })

          this.class_events = classEvents
          this.class_events.map((ce) => {
            if (this.canSeeDropDown(ce)) {
              this.can_see_action = true
            }
          })
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.class_events = []
        })
      },
      fetchForms() {
        this.busy = true
        this.error = null

        let url = `/org/${this.organization.id}/client/get_answers`
        return axios.get(url, {params: {
            //extra: ['membership_block']
        }})
        .then(response => {
          console.log(response.data)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          
        })
      },
      fetchFilledForms() {
        this.busy = true
        this.error = null

        let url = `/org/${this.organization.id}/client/get_answers`
        return axios.get(url, {params: {
            extra: ['membership_block']
        }})
        .then(response => {
          this.busy = false
          let membership_answers = []

          response.data.map((answer) => {
            if (answer.json && answer.json.dates) {
              membership_answers.push(answer.json)
              this.selected_dates = answer.json.dates
            }
          })

          let number_of_choices = 0

          membership_answers.map((answer) => {
            number_of_choices += parseInt(answer.number_of_choices)
          });

          this.number_of_choices = number_of_choices
          this.number_of_choices_clean = number_of_choices
          this.membership_answers = membership_answers

          if (membership_answers.length > 0) {
            //console.log(membership_answers)
            this.selected_membership = this.client.memberships.find(x => x.membership_id == membership_answers[0].membership_id)
            this.fetchClasses()
          }

        })
        .catch(error => {
          console.log(error)
          this.busy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
          this.forms = []
        })
      },
      fetchClasses() {
        this.classBusy = true
        this.error = null

        let url = `/org/${this.organization.id}/classes?am_only=true&no_pagination=true&events_only=true`
        return axios.get(url, {params: {
          memberships: _.compact([this.selected_membership.membership_id])
        }})
        .then(response => {
          this.classBusy = false
          this.membership_classes = response.data.classes
        })
        .catch(error => {
          this.classBusy = false
          this.error = _.errorFromAjax(error)
          this.$bvToast.toast(this.error, {
            title: trans('error'),
            variant: 'danger',
            solid: true,
          })
        })
      },
      onDateChange(date) {
        this.date = date
        this.checkNumberOfClasses()
      },
      onViewChange(view) {
        this.view = view
        this.checkNumberOfClasses()
      },
      checkNumberOfClasses() {
        let currentDate = moment(this.date)

        if (this.view == 'timeGridWeek' || this.view == 'timeGridDay') {
          let start = currentDate.clone().startOf('week')
          let end = currentDate.clone().endOf('week')

          let choices = 0
          this.class_events.map((ce) => {
            if (!!this.selected_membership &&
              moment(ce.start).isBetween(start, end) &&
              moment(ce.start).isBetween(this.selected_membership.active_at, this.selected_membership.expired_at)) {
              choices++
            }
          })

          this.number_of_classes = choices
          this.number_of_choices = this.getNumberOfChoices(start, end)
        } else if (this.view == 'dayGridMonth') {
          let start = currentDate.clone().startOf('month')
          let end = currentDate.clone().endOf('month')

          let choices = 0
          this.class_events.map((ce) => {
            if (!!this.selected_membership &&
              moment(ce.start).isBetween(start, end) &&
              moment(ce.start).isBetween(this.selected_membership.active_at, this.selected_membership.expired_at)) {
              choices++
            }
          })


          this.number_of_classes = choices
          this.number_of_choices = this.getNumberOfChoices(start, end)
        }
      },
      onEventClick(event) {
        if (!!!this.selected_membership || !this.number_of_choices || this.number_of_choices == 0) {
          return
        }

        if (event.extendedProps.isAttended) {
          this.$bvModal.msgBoxConfirm(trans('not_attend_class'), {
            title: trans('please_confirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: trans('yes'),
            cancelTitle: trans('no'),
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            if (value) {
              let class_event = this.getEventById(event.id)
              //console.log(class_event)
              //this.class_events = this.class_events.filter(item => item.id != event.id)
              this.removeParticipant(class_event.extendedProps.am_class_id, this.selected_membership.recipient_id, class_event.id).then(this.fetch).then(this.fetchClasses)
            }
          })
          .catch(err => {
              // An error occurred
          })
        } else {
          if (this.number_of_choices > this.number_of_classes) {
            this.$bvModal.msgBoxConfirm(trans('attend_class'), {
              title: trans('please_confirm'),
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'danger',
              okTitle: trans('yes'),
              cancelTitle: trans('no'),
              footerClass: 'p-2',
              hideHeaderClose: false,
              centered: true
            })
            .then(value => {
              if (value) {
                let class_event = this.getEventById(event.id)
                if (class_event.extendedProps.maximum_attendance == null || class_event.extendedProps.number_of_spots > 0) {
                  this.addParticipant(class_event.extendedProps.am_class_id, this.selected_membership.recipient_id, class_event.id).then(this.fetch).then(this.fetchClasses)
                } else {
                  this.$bvModal.msgBoxOk(trans('class_is_full'), {
                    title: trans('error'),
                    buttonSize: 'sm',
                    centered: true,
                    size: 'sm'
                  });
                }
              }
            })
            .catch(err => {
                // An error occurred
            })
          } else {
            this.$bvModal.msgBoxOk(trans('undattend_class'), {
              title: trans('error'),
              buttonSize: 'sm',
              centered: true,
              size: 'sm'
            });
          }
        }
      },
      removeParticipant(cls, participant, event) {
        this.busy = true
        this.classBusy = true
        this.error = null
        let url = `/org/${this.organization.id}/attendance/${cls}/participant/${participant}/event/${event}`
        return axios.delete(url)
        .then(response => {
          this.busy = false
          this.classBusy = false
        })
        .catch(error => {
          this.busy = false
          this.busy = false
          this.classBusy = false
          this.error = _.errorFromAjax(error)
        })
      },
      addParticipant(cls, participant, event) {
        this.busy = true
        this.classBusy = true
        this.error = null
        let url = `/org/${this.organization.id}/attendance/${cls}/participant/${participant}/event/${event}`
        return axios.post(url)
        .then(response => {
          this.busy = false
          this.classBusy = false
        })
        .catch(error => {
          this.busy = false
          this.busy = false
          this.classBusy = false
          this.error = _.errorFromAjax(error)
        })
      },
      getNumberOfChoices(start, end) {
        let dates = []
        for (var am_class in this.selected_dates){
          dates = [...dates, ...this.selected_dates[am_class]]
        }

        let days = []
        dates.map((date) => {
          days.push(moment(date).day());
        })

        let days_in_diff = this.getDaysBetweenDates(start, end)
        let days_diff = []
        days_in_diff.map((date) => {
          days_diff.push(moment(date).day());
        })

        let choices = 0;
        days_diff.map((dd) => {
          if (days.includes(dd)) {
            choices++
          }
        })

        return choices
      },
      getDaysBetweenDates(startDate, endDate) {
        var dates = [];
        if (!!this.selected_membership && this.client.memberships.length > 0 &&
          startDate.isBefore(this.selected_membership.active_at)) {
          startDate = moment(this.selected_membership.active_at)
        }

        if (!!this.selected_membership && this.client.memberships.length > 0 &&
          endDate.isAfter(this.selected_membership.expired_at)) {
          endDate = moment(this.selected_membership.expired_at)
        }

        dates.push(startDate)
        while (startDate.add(1, 'days').diff(endDate) < 0) {
          dates.push(startDate.clone().toDate());
        }

        return dates
      },
      getClassesByDates(start, end) {
        let classes = []
        this.membership_classes.map((am_class) => {
          am_class.events.map((event) => {
            if (moment(event.start).isBetween(start, end)) {
              classes.push(event)
            }
          })
        });

        return classes;
      },
      getEventById(id) {
        let events = []
        this.membership_classes.map((am_class) => {
          events = [...am_class.events, ...events]
        });

        return events.find(x => x.id == id)
      },
      getMembershipInfoFromClass(memberships) {
        let result = memberships.filter(o1 => !this.client.memberships.some(o2 => o1.id === o2.id))
        //console.log(result)
        //this.client.memberships.find()
      },
      viewAttendance(event) {
        this.selected_event = event
        this.$bvModal.show('client-attendance-modal')
      },
      markAbsent(event) {
        if (event.marked_absent_at) {
          this.$bvModal.msgBoxOk('already_marked_absent_at');
          return
        }

        this.$bvModal.msgBoxConfirm(trans('are_you_sure_mark_absent'), {
          title: trans('are_you_sure'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: trans('yes'),
          cancelTitle: trans('cancel'),
        })
        .then(confirmed => {
          if (!confirmed) {
            return;
          }

          this.busy = true
          let url = `/org/${this.organization.id}/eventrecipient/${event.event_recipient_id}/event/${event.id}/mark_absent`
          return axios.post(url)
          .then(response => {
            this.busy = false
            this.fetch()
          })
          .catch(error => {
            this.busy = false
            this.busy = false
            this.classBusy = false
            this.error = _.errorFromAjax(error)
          })

        });
      },
      checkIn(event) {
        if (event.in_at) {
          this.$bvModal.msgBoxOk('already_checked_in');
          return
        }
        this.busy = true
        let url = `/org/${this.organization.id}/eventrecipient/${event.event_recipient_id}/event/${event.id}`
        return axios.post(url)
        .then(response => {
          this.busy = false
          this.fetch()
        })
        .catch(error => {
          this.busy = false
          this.busy = false
          this.classBusy = false
          this.error = _.errorFromAjax(error)
        })
      },
      cancelClass(event, isAdmin) {
        this.$bvModal.msgBoxConfirm(trans('are_you_sure_cancel_class'), {
          title: trans('are_you_sure'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: trans('yes'),
          cancelTitle: trans('cancel'),
        })
        .then(confirmed => {
          if (!confirmed) {
            return;
          }

          this.busy = true

          let data = {
            ...event.am_class_meta,
            is_admin: this.adminCanChangeClient
          }
         
          let url = `/org/${this.organization.id}/eventrecipient/${event.event_recipient_id}/event/${event.id}`
          return axios.delete(url, { data: data })
          .then(response => {
            this.busy = false
            let location = response.data
            this.fetch()

            this.$bvModal.msgBoxConfirm(trans('success_cancel_class'), {
              title: trans('success'),
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              okTitle: trans('yes'),
              cancelTitle: trans('cancel'),
            })
            .then(confirmed => {
              if (!confirmed) {
                return;
              }
              window.location = location
            })
            .catch(error => {
              this.busy = false
              this.busy = false
              this.classBusy = false
              this.error = _.errorFromAjax(error)
            })
          }).catch(error => {
              this.error = _.errorFromAjax(error)
              this.busy = false
              this.busy = false
              this.classBusy = false
              this.$bvToast.toast(this.error, {
                title: trans('error'),
                variant: 'danger',
                solid: true,
              })
            })
        })
      }
    },
    mounted() {
      window.myClasses = this
      this.fetch()
      //this.fetchForms()
      if (this.client.memberships && this.client.memberships.length > 0) {
        this.membership_options = this.client.memberships.map((mem) => {
          return {
            value: mem.membership_id,
            text: mem.membership_name
          }
        })
        //this.fetchFilledForms()
      }
    },
  }
</script>
